// vuex@next https://next.vuex.vuejs.org/
// vuex-persistedstate https://github.com/robinvdvleuten/vuex-persistedstate

import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import getters from './getters'
import user from './modules/user'
import cachePages from './modules/cachePages'

export const store = createStore({
  modules: {
    user,
    cachePages
  },
  getters,
  plugins: [createPersistedState()]
})
